/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Filter_All_ActivitiesInputs */

const vi_care_log_filter_all_activities = /** @type {(inputs: Care_Log_Filter_All_ActivitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả hoạt động`)
};

/**

* @param {Care_Log_Filter_All_ActivitiesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_filter_all_activities = /** @type {((inputs?: Care_Log_Filter_All_ActivitiesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Filter_All_ActivitiesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_filter_all_activities(inputs)
});